import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsSummaryData } from "@/http/api-types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { secondsToDays } from "./formatters";

export function CycleTimeTrendChart({ data }: { data: JiraMetricsSummaryData["cycle_trend"] }) {
  const chartData = data.map(point => ({
    period: point.period,
    avg_days: secondsToDays(point.avg_cycle_seconds),
    median_days: secondsToDays(point.median_cycle_seconds),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cycle Time Trend (Avg vs Median)</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          className="h-72 w-full"
          config={{
            avg_days: { label: "Avg Cycle (workdays)", color: "#0ea5e9" },
            median_days: { label: "Median Cycle (workdays)", color: "#f59e0b" },
          }}
        >
          <LineChart data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="period" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Line type="monotone" dataKey="avg_days" stroke="var(--color-avg_days)" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="median_days" stroke="var(--color-median_days)" strokeWidth={2} dot={false} />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
